var render, staticRenderFns
import script from "./FavoriteAuctions.vue?vue&type=script&lang=js"
export * from "./FavoriteAuctions.vue?vue&type=script&lang=js"
import style0 from "./FavoriteAuctions.vue?vue&type=style&index=0&id=5357b000&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5357b000",
  null
  
)

export default component.exports